import isFunction from 'lodash/isFunction';
import { getReportType } from '@/reports/utils';

function sendObjectMetadata (objectId: string, objectProperty: string, metadata: Record<string, unknown>): void {
    if (!objectId || !objectProperty) return;
    if (!isFunction(window.pendo?.objectMetadata)) return;

    window.pendo.objectMetadata(objectId, objectProperty, metadata);
}

export function sendReportObjectMetadata (report: {
    id: string;
    name?: string;
    type?: string;
    kind?: string;
    definition?: { type?: string };
}): void {
    if (!report?.id) return;

    sendObjectMetadata(report.id, 'reportId', {
        name: report.name,
        reportType: getReportType(report),
    });
}

export function sendDashboardObjectMetadata (dashboard: { id: string; name?: string }): void {
    if (!dashboard?.id) return;

    sendObjectMetadata(dashboard.id, 'dashboardId', { name: dashboard.name });
}

export function sendGuideObjectMetadata (guide: { id: string; name?: string }): void {
    if (!guide?.id) return;

    sendObjectMetadata(guide.id, 'guideId', { name: guide.name });
}
